import { render, staticRenderFns } from "./PopupShareTip.vue?vue&type=template&id=669e4908"
import script from "./PopupShareTip.vue?vue&type=script&lang=js"
export * from "./PopupShareTip.vue?vue&type=script&lang=js"
import style0 from "./PopupShareTip.vue?vue&type=style&index=0&id=669e4908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports